import script from "./MyProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProfile.vue?vue&type=script&setup=true&lang=js"

import "./MyProfile.vue?vue&type=style&index=0&id=4ceaa3c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ceaa3c9"]])

export default __exports__